import { ChangeDetectionStrategy, Component, ContentChildren, HostBinding, Input } from '@angular/core';
import { DropdownItemComponent } from './dropdown-item.component';

@Component({
  selector: 'mtg-dropdown-group',
  templateUrl: './dropdown-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownGroupComponent {
  @Input()
  title: string;
  @ContentChildren(DropdownItemComponent)
  items: DropdownItemComponent[];
  @HostBinding('class.dropdown-group')
  defaultClass = true;
}
